import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { DEFAULT_LETTERHEAD } from '../data/company'
import type { Letterhead, SablonSurum } from '../types'
import { SidePanelSection } from './SidePanelSection'

const KEYS = ['companyName', 'legalName', 'department'] as const satisfies readonly (keyof Letterhead)[]

type Props = { surum: SablonSurum; onChange: (letterhead: Partial<Letterhead>) => void }

export function LetterheadForm({ surum, onChange }: Props) {
  const { t } = useTranslation()
  const current = surum.letterhead ?? {}

  return (
    <SidePanelSection title={t('hr.belgeler.right.letterhead')}>
      <div className="space-y-2.5">
        {KEYS.map((key) => (
          <div key={key} className="space-y-1.5">
            <Label htmlFor={`lh-${key}`} className="text-xs">
              {t(`hr.belgeler.right.${key}`)}
            </Label>
            <Input
              id={`lh-${key}`}
              value={current[key] ?? DEFAULT_LETTERHEAD[key]}
              placeholder={DEFAULT_LETTERHEAD[key]}
              maxLength={80}
              onChange={(e) => onChange({ ...current, [key]: e.target.value })}
            />
          </div>
        ))}
        <p className="text-[11px] leading-relaxed text-muted-foreground">{t('hr.belgeler.right.letterheadHint')}</p>
      </div>
    </SidePanelSection>
  )
}
